<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://cabcard.services">CabCard Services</a>
          </li>
          <li>
            <a href="https://cabcard.services/support">Support</a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; {{ year }} Magnus 1265 Ltd | <span>v2309131457</span>
      </div>
      <payment-services-statement></payment-services-statement>
    </div>
  </footer>
</template>
<script>
import PaymentServicesStatement from "src/components/UIComponents/PaymentServicesStatement.vue";

export default {
  components: {
    PaymentServicesStatement,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
